import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'Website',
  subtitle: 'Maintenance',
  tagline: 'Keep Your Website Healthy',
  icon: '',
  // icon: '🔧',

  heroDesc: 'A website needs regular care to stay fast, secure, and up-to-date. Our maintenance plans take the technical burden off your shoulders so you can focus on running your business.',
  mainStat: '100%',
  mainStatLabel: 'Of clients report better performance after maintenance',
  subStats: [{ value: '<4hr', label: 'Avg Issue Resolution' }, { value: 'Monthly', label: 'Performance Reports' }],
  features: [
    { icon: '🔄', title: 'Regular Updates', desc: 'CMS, plugins, and themes kept up-to-date for security and performance.' },
    { icon: '🔒', title: 'Security Monitoring', desc: 'Continuous malware scanning and security patching.' },
    { icon: '⚡', title: 'Speed Optimization', desc: 'Regular performance checks and optimizations to keep your site fast.' },
    { icon: '💾', title: 'Weekly Backups', desc: 'Automated backups so your website can be restored if anything goes wrong.' },
    { icon: '🐛', title: 'Bug Fixes', desc: 'Quick resolution of any technical issues, broken links, or display problems.' },
    { icon: '📊', title: 'Monthly Reports', desc: 'Detailed reports on uptime, performance, and all work completed.' },
  ],
  benefits: [
    { title: 'Prevent Security Breaches', desc: 'Regular updates and monitoring prevent hackers from exploiting vulnerabilities.' },
    { title: 'Maintain Fast Load Speed', desc: 'Regular optimization keeps your website loading quickly as it grows.' },
    { title: 'Zero Unexpected Downtime', desc: 'Proactive maintenance prevents issues before they take your site offline.' },
    { title: 'Focus on Your Business', desc: 'Hand over all technical responsibilities to experts and focus on what matters.' },
  ],
  process: [
    { title: 'Initial Audit', desc: 'Complete website audit to identify existing issues and establish a baseline.' },
    { title: 'Fix & Optimize', desc: 'Resolve all existing issues and implement performance improvements.' },
    { title: 'Set Up Monitoring', desc: 'Configure uptime monitoring, security scans, and backup schedules.' },
    { title: 'Monthly Maintenance', desc: 'Regular updates, backups, checks, and optimizations every month.' },
    { title: 'Reporting', desc: 'Monthly report delivered with full details of all work completed.' },
  ],
  whyChoose: [
    { icon: '⚡', title: 'Fast Response Time', desc: 'Critical issues addressed within 4 hours. Minor issues within 24 hours.' },
    { icon: '🔒', title: 'Proactive Security', desc: 'We fix vulnerabilities before hackers can exploit them.' },
    { icon: '📞', title: 'Dedicated Support', desc: 'A dedicated maintenance team that knows your website inside and out.' },
    { icon: '📋', title: 'Detailed Reporting', desc: 'Full transparency on everything we do to maintain your website.' },
  ],
  reviews: [
    { name: 'Ashwin Kumar', role: 'Digital Agency', text: 'DMS handles maintenance for all our client websites. Reliable, fast, and thorough.' },
    { name: 'Geeta Sharma', role: 'NGO Director', text: 'Our website was hacked before DMS. Since their maintenance plan, zero security incidents.' },
    { name: 'Rajan Pillai', role: 'Hotel Owner', text: 'Worth every rupee. My website is faster and more secure than it\'s ever been.' },
  ],
  faq: [
    { q: 'What does the maintenance plan include?', a: 'Updates, backups, security monitoring, speed optimization, bug fixes, and monthly reporting.' },
    { q: 'Is there a minimum contract period?', a: 'We offer monthly and annual maintenance contracts. Annual plans come with a discount.' },
    { q: 'What happens if my website gets hacked?', a: 'We will clean the malware and restore your website from the latest backup at no extra charge.' },
  ],
};

export default function WebsiteMaintenance() {
  return <ServiceTemplate data={data} />;
}
